// Lightweight browser TTS shared by the guided demo tour (reuses Aria's voice settings).
const synth = typeof window !== "undefined" ? window.speechSynthesis : null;
const FEMALE_HINTS = ["female", "samantha", "victoria", "karen", "moira", "tessa", "fiona", "zira",
  "aria", "jenny", "neerja", "swara", "google uk english female", "google us english", "serena", "allison"];

let voices = [];
function loadVoices() { try { voices = synth ? synth.getVoices() : []; } catch { voices = []; } }
if (synth) { loadVoices(); synth.addEventListener?.("voiceschanged", loadVoices); }

function pickVoice(lang = "en-US") {
  const vs = voices.length ? voices : (synth ? synth.getVoices() : []);
  const saved = (typeof localStorage !== "undefined" && localStorage.getItem("yl_aria_voice")) || "";
  if (saved) { const sel = vs.find((v) => v.voiceURI === saved); if (sel) return sel; }
  const two = lang.slice(0, 2).toLowerCase();
  const byLang = vs.filter((v) => (v.lang || "").toLowerCase().startsWith(two));
  const pool = byLang.length ? byLang : vs;
  const indian = pool.find((v) => /india|neerja|en-in|hi-in/i.test((v.lang || "") + (v.name || "")));
  const female = pool.find((v) => FEMALE_HINTS.some((n) => (v.name || "").toLowerCase().includes(n)));
  return indian || female || pool[0] || null;
}

export function isMuted() {
  return typeof localStorage !== "undefined" && localStorage.getItem("yl_aria_muted") === "1";
}

export function cancelSpeech() {
  try { synth?.cancel(); } catch { /* noop */ }
}

export function speak(text, opts = {}) {
  const { lang = "en-US", onEnd } = opts;
  if (!synth || !text || isMuted()) return;
  cancelSpeech();
  const clean = String(text).replace(/\*\*/g, "").replace(/[•*#_>`]/g, "");
  const u = new SpeechSynthesisUtterance(clean);
  u.lang = lang;
  const v = pickVoice(lang);
  if (v) u.voice = v;
  u.rate = 1.03; u.pitch = 1.06;
  u.onend = () => { try { onEnd?.(); } catch { /* noop */ } };
  u.onerror = () => { try { onEnd?.(); } catch { /* noop */ } };
  try { synth.speak(u); } catch { /* noop */ }
}
